import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUserRole } from "../hooks/useUserRole";
import { isPathAllowed } from "../layouts/navConfigs";

interface RoleGuardProps {
  children: React.ReactNode;
}

/**
 * Wraps any auth-protected route element.
 * If the logged-in user's role does not have access to the current path,
 * they are redirected to the 404 page instead of seeing the content.
 */
const RoleGuard: React.FC<RoleGuardProps> = ({ children }) => {
  const role     = useUserRole();
  const location = useLocation();

  if (!isPathAllowed(role, location.pathname)) {
    return <Navigate to="/error-404" replace />;
  }

  return <>{children}</>;
};

export default RoleGuard;
